import React from 'react';
import { translations } from '../translations';
import { FaCheckCircle } from 'react-icons/fa';

const Dashboard = ({ language }) => {
    const features = [
        translations[language]['dashboard.features.1'],
        translations[language]['dashboard.features.2'],
        translations[language]['dashboard.features.3'],
        translations[language]['dashboard.features.4']
    ];

    return (
        <section className="dashboard" id="solutions">
            <div className="dashboard-container">
                <div className="dashboard-content">
                    <h3 className="chinese-font">{translations[language]['dashboard.title']}</h3>
                    <p className="chinese-font">{translations[language]['dashboard.subtitle']}</p>
                    <ul className="feature-list">
                        {features.map((feature, index) => (
                            <li key={index}>
                                <FaCheckCircle /> <span className="chinese-font">{feature}</span>
                            </li>
                        ))}
                    </ul>
                    <a href="#demo" className="btn btn-primary">{translations[language]['dashboard.cta']}</a>
                </div>
                <div className="dashboard-image">
                    <img src="/assets/images/dashboard.png" alt="OptiWare Dashboard" />
                </div>
            </div>
        </section>
    );
};

export default Dashboard;
